import { UnitTypes } from '@/constants/units'

export default {
  [UnitTypes.APARTMENT]: 'Apartamento',
  [UnitTypes.AMENITIES]: 'Amenities',
  [UnitTypes.OFFICE]: 'Oficina',
  [UnitTypes.SHOP]: 'Local',
  [UnitTypes.HOUSE]: 'Casa',
}
